import {
  LoadAdminUsers,
  LoadAdminUsersCompleted,
  LoadAdminUsersFailed,
  LoadDetailedUsers,
  LoadDetailedUsersCompleted,
  LoadDetailedUsersFailed,
  LoadUserFromLoggedInUser,
  LoadUserFromLoggedInUserFailed,
  LoadUsers,
  LoadUsersCompleted,
  LoadUsersFailed,
  ResetSelectedUser,
  SelectUser,
  SelectUserFailed,
  UpdateUser,
  UserDetailRequest,
  UserDetailRequestRejected,
  UserUpdated,
  UserUpdateFailed } from 'app/core/user/state/actions/index';

import {
  LoadSingleUser,
  LoadSingleUserCompleted,
  LoadSingleUserFailed,
  LoadUserErgoTeam,
  LoadUserErgoTeamCompleted,
  LoadUserErgoTeamFailed,
} from './user-load.action';

import {
  AddErgoTeamMember,
  AddErgoTeamMemberCompleted,
  AddErgoTeamMemberFailed,
  CreateUser,
  CreateUserCompleted,
  CreateUserFailed,
} from './user-create.action';

import {
  DeleteUser,
  DeleteUserCompleted,
  DeleteUserFailed,
  RemoveErgoTeamMember,
  RemoveErgoTeamMemberCompleted,
  RemoveErgoTeamMemberFailed,
} from './user-delete.action';

export {
  LoadAdminUsers,
  LoadAdminUsersCompleted,
  LoadAdminUsersFailed,
  LoadDetailedUsers,
  LoadDetailedUsersCompleted,
  LoadDetailedUsersFailed,
  LoadUserFromLoggedInUser,
  LoadUserFromLoggedInUserFailed,
  LoadUsers,
  LoadUsersCompleted,
  LoadUsersFailed,
} from './user-load.action';
export { ResetSelectedUser, SelectUser, SelectUserFailed } from './user-select.action';
export { UserActionType } from './user-action-type.enum';
export { UserDetailRequest, UserDetailRequestRejected } from './user-detail.action';
export { UpdateUser, UserUpdated, UserUpdateFailed } from './user-update.action';

export type UserActions =
  LoadSingleUser |
  LoadSingleUserCompleted |
  LoadSingleUserFailed |
  LoadUserErgoTeam |
  LoadUserErgoTeamCompleted |
  LoadUserErgoTeamFailed |
  LoadAdminUsers |
  LoadAdminUsersCompleted |
  LoadAdminUsersFailed |
  LoadDetailedUsers |
  LoadDetailedUsersCompleted |
  LoadDetailedUsersFailed |
  LoadUserFromLoggedInUser |
  LoadUserFromLoggedInUserFailed |
  LoadUsers |
  LoadUsersCompleted |
  LoadUsersFailed |
  ResetSelectedUser |
  SelectUser |
  SelectUserFailed |
  UserDetailRequest |
  UserDetailRequestRejected |
  UpdateUser |
  UserUpdated |
  UserUpdateFailed |
  CreateUser |
  CreateUserCompleted |
  CreateUserFailed |
  AddErgoTeamMember |
  AddErgoTeamMemberCompleted |
  AddErgoTeamMemberFailed |
  DeleteUser |
  DeleteUserCompleted |
  DeleteUserFailed |
  RemoveErgoTeamMember |
  RemoveErgoTeamMemberCompleted |
  RemoveErgoTeamMemberFailed;
